import { render, staticRenderFns } from "./all_news.vue?vue&type=template&id=dd5889dc&"
import script from "./all_news.vue?vue&type=script&lang=js&"
export * from "./all_news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports